import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { getActiveTabId, PromotionHistoryTabs } from './PromotionHistoryTabs/PromotionHistoryTabs';
import { RewardTab } from './PromotionHistoryTabs/RewardTab/RewardTab';
import { BonusStore } from 'src/domains/casino/state/AppCasino/store/campaign-store/Bonus.store';
import { BonusBalanceTab } from './PromotionHistoryTabs/BonusBalanceTab/BonusBalanceTab';
import { RewardType } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/BonusCardState';

export interface PromotionHistoryPropsType {
    userId: number;
}

export const PromotionHistory = observer('PromotionHistory', (props: PromotionHistoryPropsType) => {
    const { common, routerBackoffice } = useAppStateContext();

    const bonusStore = BonusStore.get(common, props.userId);

    const activeTabId = getActiveTabId(routerBackoffice);

    return (
        <div
            className='flex flex-col flex-auto min-h-full max-h-screen gap-6 p-6 overflow-x-hidden overflow-y-auto bg-white text-foreground flex-nowrap font-tertiary'
            style={{ scrollbarGutter: 'stable' }}
        >
            <PromotionHistoryTabs activeTabId={activeTabId} />

            {activeTabId === 'free-bets' && (
                <RewardTab
                    type={RewardType.Bets}
                    userId={props.userId}
                    bonusModels={() => bonusStore.allFreeBets}
                />
            )}

            {activeTabId === 'free-spins' && (
                <RewardTab
                    type={RewardType.Spins}
                    userId={props.userId}
                    bonusModels={() => bonusStore.allFreeSpins}
                />
            )}

            {activeTabId === 'bonus-balance' && (
                <BonusBalanceTab
                    userId={props.userId}
                    bonusWinningsModels={() => bonusStore.allBonusWinnings}
                />
            )}

            {activeTabId === 'campaigns' && <>Load campaigns component</>}
        </div>
    );
});
